import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const rootElement = document.getElementById('root');

// scripts/prerender.mjs bakes the per-route/language <head> into the static
// HTML at build time (that is what crawlers read). The body is always rendered
// on the client with createRoot rather than hydrateRoot: the language-prefixed
// router basename makes byte-perfect hydration across sr/en/de fragile, and a
// clean client mount avoids React hydration-mismatch errors while leaving the
// pre-rendered <head> untouched.
createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
